import auth from './auth';
import app from './app';

const routes = [
  app,
  auth
];

export default routes;



// WEBPACK FOOTER //
// ./src/plugins/routes/index.js